import React from 'react';
export default {
  'cart': {
    'change-currency': 'Währung ändern',
    'and-then': 'und dann',
    'plus-tax': ' + MwSt.',
    'for': 'Für',
    'edit': {
      'label': 'Bearbeiten',
      'submit': 'Anwenden'
    },
    'empty': 'Sie haben noch nichts zu Ihrer Bestellung hinzugefügt.',
    'free': 'Kostenlos',
    'promo-code': {
      'add': 'Geschenkgutschein oder Aktionscode hinzufügen',
      'error': {
        'invalid-for-subscription': 'Der Gutscheincode ist für diese Bestellung nicht gültig.'
      },
      'label': 'Geschenkgutschein oder Aktionscode',
      'submit': 'Anwenden'
    },
    'subtotal-line': {
      'tax-label': 'Geschätzte MwSt.',
      'subtotal': 'Zwischensumme',
      'tax': 'Steuern',
      'gift-card': 'Geschenkkarte'
    },
    'starting-price': 'Startpreis',
    'title': 'Bestellübersicht',
    'setup-fee': 'Einrichtungs-Gebühr',
    'free-trial': 'Kostenlose Testversion',
    'total-line': {
      'label': 'Gesamtbetrag'
    },
    'order-total-line': {
      'label': 'Gesamtauftrag'
    }
  },
  'address': {
    'country': 'Land',
    'address2': 'Wohnung, Appartement, usw.',
    'tax-identifier': 'Steuernummer',
    'tax-identifier-type': 'Steuernummertyp',
    'first-name': 'Vorname',
    'last-name': 'Nachname',
    'company-name': 'Firmenname',
    'address1': 'Straße und Hausnummer',
    'city': 'Stadt',
    'state': 'Bundesland',
    'postal-code': 'Postleitzahl',
    'phone-number': 'Telefonnummer',
    'vat-number': 'USt-IdNr./Steuer-ID'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Angaben zur Karte',
      'expiry': 'MM/JJ',
      'name': 'Kreditkarte',
      'number': 'Kreditkartennummer',
      'cvv': 'Prüfziffer',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'Bankkonto',
      'routing-number': 'Bankleitzahl',
      'account-number': 'Kontonummer',
      'account-number-confirmation': 'Bestätigung Kontonummer',
      'account-type': {
        'label': 'Kontotyp',
        'checking': 'Girokonto',
        'savings': 'Sparkonto'
      },
      'name-on-account': 'Kontoninhaber'
    },
    'amazon': {
      'name': 'Amazon'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Sort Code'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'BSB Code'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Rechnungsadresse',
  'billing-address-same-as-shipping': 'Identisch mit der Lieferadresse',
  'submit': 'Jetzt bezahlen',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} ausgewählt</>,
  'express-checkout': 'Express-Kaufabwicklung',
  'change-payment-method': 'Zahlungsmethode ändern',
  'day': 'Tag',
  'days': 'Tage',
  'week': 'Woche',
  'weeks': 'Wochen',
  'month': 'Monat',
  'months': 'Monate',
  'year': 'Jahr',
  'years': 'Jahre',
  'confirmation': {
    'title': 'Vielen Dank für Ihre Bestellung',
    'order-num': ({ number }: { number: number }) => <>Bestellnr. {number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Abgeschlossen am {date}</>,
    'email-notice': 'Sie erhalten eine E-Mail-Bestätigung Ihrer Bestellung.',
    'payment': 'Zahlung',
    'return-to': ({ name }: { name: string }) => <>Zurück zu {name}</>,
    'credit-applied': 'Guthaben angewendet'
  },
  'back': 'Zurück',
  'contact-info': 'Kontakt Informationen',
  'email-address': 'email',
  'payment-info': 'Rechnungsdaten',
  'shipping-address': 'Lieferanschrift',
  'legal': {
    'accept': 'Ich akzeptiere die',
    'privacy-policy': 'Datenschutzerklärung',
    'terms-of-service': 'Service-Bedingungen'
  },
  'recurring': {
    'consent': `Ich stimme zu, die oben aufgeführten Kosten, die mit einem Abrechnungsrhythmus angezeigt werden,
                auf wiederkehrender Basis zu zahlen, sofern das Abonnement nicht vor Ende des laufenden
                Abrechnungszeitraums gekündigt wird.`,
    'cancel': 'Um Ihr Abonnement zu kündigen, rufen Sie Ihre Kontoverwaltungsseite auf.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'Tag' : 'Tage',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'Woche' : 'Wochen',
    'months': ({ count }: { count: number }) => count === 1 ? 'Monat' : 'Monate',
    'years': ({ count }: { count: number }) => count === 1 ? 'Jahr' : 'Jahre'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string, addOnName: string }) => <>Ihnen werden {amount}/Einheit berechnet für {addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string, units: number, unitsLabel: string, addOnName: string }) => <>Ihnen werden {amount} für {units} {unitsLabel} von {addOnName}.</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string, amount: string, intervalLengthLabel: string, taxable?: boolean }) => <>Ab {startDate} werden Ihnen {amount}/{intervalLengthLabel}{taxable ? ' + Steuern' : ''} berechnet</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string, amount: string, intervalLengthLabel: string, setupFee: string, taxable?: boolean }) => <>Ab {startDate} werden Sie {amount}/{intervalLengthLabel}{taxable ? ' + Steuern' : ''} berechnet, zusammen mit einer einmaligen Gebühr von {setupFee}</>,
      'cancellation.reminder': 'Sie erhalten eine E-Mail-Erinnerung {days} Tage vor Beginn der Abrechnung.',
      'trial.start': ({ trialLength, trialInterval }: { trialLength: number, trialInterval: string }) => <>Ihre kostenlose {trialLength} {trialInterval} Testversion beginnt heute.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>Um zu vermeiden, dass Ihnen Kosten entstehen, müssen Sie vor {trialEndsAt} kündigen.</>,
      'email.reminder': ({ days }: { days: number }) => <>Sie erhalten eine E-Mail-Erinnerung {days} Tage vor Beginn der Abrechnung.</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Ihr Abonnement endet am {billingEndsAt} und wird nicht automatisch verlängert.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string, newChargeAmount: string }) => <>Nach {afterChargeTime} werden Sie {newChargeAmount} + Steuern berechnet.</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Ihr Abonnement wird automatisch alle {totalCyclesLengthLabel} verlängert und bleibt bestehen, bis Sie es kündigen.</>,
      'title': 'Abonnementdetails',
    },
    'agreement.button': 'Zustimmen & Fortfahren',
    'agreement.text': 'Durch Klicken auf "Zustimmen & Fortfahren" bestätigen Sie, dass Sie diese Abonnementbedingungen verstehen und akzeptieren. Es fallen keine Gebühren an, bis Sie den Checkout abschließen.',
    'changeOrCancel': 'Um Ihr Abonnement zu ändern oder zu kündigen ',
    'access-account': 'auf Ihr Konto zugreifen',
    'contact-support': 'Support kontaktieren',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' und ',
      'lastWordConnector': ' und '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>Rechnungsstellung bereitgestellt durch {recurly}</>,
  'errors': {},
  'subscribe': 'Abonnieren'
};
